import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiGateway } from "api/api-gateway";
import { PageOptions } from "../interface/pageOptions";

@Injectable({
    providedIn: "root",
})
export class ExamsService {
    constructor(private apiGateway: ApiGateway) {}

    buscarExams(
        idPaciente: number,
        type: number,
        pageOptions: PageOptions
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .post(`document/app/list/${idPaciente}/${type}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    buscarDocument(idDocumento: number, idPaciente: number) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    `document/pdf/gcp/${idDocumento}?paciente=${idPaciente}&sistema=${1}`
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    buscarRequest(idDocumento: number, idPaciente: number) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    `document-model/pdf/${idDocumento}?receituario=${idDocumento}&sistema=${1}`
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }
}
